<template>
  <div id="table-default">
    <vs-table
      noDataText="Sem resultados"
      dense
      ref="table"
      search
      maxHeight="63vh"
      max-items="1000"
      pagination
      :data="rows"
    >
      <div
      v-if="canEdit"
        slot="header"
        class="flex flex-wrap-reverse items-center flex-grow justify-between"
      >
        <div
          class="flex flex-wrap-reverse items-center data-list-btn-container"
        >
          <div class="vx-row">
            <div class="vx-col">
              <AddData
                :title="`Adicionar ${title}`"
                :url="url"
                @done="doneAddData"
              />
            </div>
            <div class="vx-col">
              <vs-button
                @click="
                  filtro.lixeira = !filtro.lixeira;
                  getData();
                "
                class="w-full"
                :type="filtro.lixeira ? 'filled' : 'border'"
                :color="filtro.lixeira ? 'danger' : 'primary'"
                >Lixeira</vs-button
              >
            </div>
          </div>
        </div>
      </div>

      <template slot="thead">
        <vs-th width="1%" sort-key="id">I.D</vs-th>
        <vs-th width="49%" sort-key="nome">Nome</vs-th>
        <vs-th width="42%" sort-key="objetivo">Objetivo</vs-th>
        <vs-th  v-if="canEdit" width="8%">Ações</vs-th>
      </template>

      <template slot-scope="{ data }">
        <vs-tr
          :data="tr"
          :key="indextr"
          v-for="(tr, indextr) in data"
          :state="getRowColor(tr)"
        >
          <vs-td>
            <p class="row-max-width font-medium">{{ tr.id }}</p>
          </vs-td>
          <vs-td>
            <p class="row-max-width font-medium">{{ tr.nome }}</p>
          </vs-td>
          <vs-td>
            <p class="row-max-width font-medium">
              {{ tr.objetivo }}
            </p>
          </vs-td>
          <vs-td class="whitespace-no-wrap"  v-if="canEdit">
            <div class="vx-row">
              <div class="vx-col w-1/3" v-if="tr.lixeira != 1">
                <EditData
                  :title="`Editar ${title}`"
                  :url="url"
                  @done="doneEditData"
                  :itemCopy="tr"
                />
              </div>
              <div class="vx-col w-1/3">
                <vx-tooltip
                  :text="tr.lixeira != 1 ? 'Excluir' : 'Restaurar'"
                  color="primary"
                  position="left"
                >
                  <feather-icon
                    v-if="tr.lixeira != 1"
                    icon="TrashIcon"
                    svgClasses="hover:text-danger stroke-current mt-1 pointer"
                    @click.stop="deleteData(tr.id)"
                  />
                  <feather-icon
                    v-else
                    icon="RefreshCwIcon"
                    svgClasses="hover:text-success stroke-current mt-1 pointer"
                    @click.stop="restoreData(tr.id)"
                  />
                </vx-tooltip>
              </div>
            </div>
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>
  </div>
</template>

<script>
import AddData from ".//components/AddTipo.vue";
import EditData from ".//components/EditTipo.vue";

export default {
  components: {
    AddData,
    EditData,
  },
  data() {
    return {
      rows: [],
      url: this.$route.meta.url,
      title: this.$route.meta.itemTitle,
      filtro: { lixeira: false },
      canEdit: this.$authPermissions.includes(this.$authFunctions.find(x => x.nome == 'Manter parametros de indicadores').id)
    };
  },
  computed: {},
  methods: {
    getRowColor(item) {
      if (item.lixeira == 1) return "danger";
      // return "primary";
    },
    async doneAddData() {
      await this.getData();
    },
    async doneEditData() {
      await this.getData(0);
    },
    async getData(load = true) {
      load ? await this.$vs.loading() : 1;
      try {
        this.rows = await this.$http.get(
          `${this.url}?lixeira=${this.filtro.lixeira}`
        );
      } catch (err) {
        const error = this.$httpErrors(err);
        this.$vs.notify(error);
      } finally {
        load ? await this.$vs.loading.close() : 1;
      }
    },
    async deleteData(id) {
      await this.$vs.loading();
      try {
        await this.$http.delete(`${this.url}/${id}`);
        await this.getData(0);
      } catch (err) {
        const error = this.$httpErrors(err);
        this.$vs.notify(error);
      } finally {
        await this.$vs.loading.close();
      }
    },
    async restoreData(id) {
      await this.$vs.loading();
      try {
        await this.$http.put(`${this.url}/${id}`, { lixeira: 0 });
        await this.getData(0);
      } catch (err) {
        const error = this.$httpErrors(err);
        this.$vs.notify(error);
      } finally {
        await this.$vs.loading.close();
      }
    },
  },
  created() {},
  async mounted() {
    await this.getData();
  },
};
</script>
